import { ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS, AdminManagementCompaniesService } from "@/service/api/admin-management-companies";
import { useQuery } from "@tanstack/react-query";

interface UseManagerCompanyDetailsParams {
  id: string;
  enabled?: boolean;
}

const useManagerCompanyDetails = ({ id, enabled }: UseManagerCompanyDetailsParams) => {
  const query = useQuery({
    queryKey: [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_MANAGEMENT_COMPANY(id)],
    queryFn: () => AdminManagementCompaniesService.getManagementCompany(id),
    enabled,
  });

  return query;
};

export default useManagerCompanyDetails;
